import { z } from 'zod';
import { airportOptionSchema } from './primitives.schema.js';
export const carRentalDetailsSchema = z.object({
    id: z.string(),
    details: z.string(),
    fromDate: z.coerce.date(),
    location: z.string(),
    price: z.number(),
    reservationConditions: z.string(),
    specifications: z.string(),
    toDate: z.coerce.date(),
});
export const hotelDetailsSchema = z.object({
    id: z.string(),
    name: z.string(),
    fromDate: z.coerce.date(),
    hotelUrl: z.string(),
    location: z.string(),
    numberOfStars: z.number(),
    price: z.number(),
    reservationConditions: z.string(),
    roomType: z.string(),
    toDate: z.coerce.date(),
    transferDescription: z.string().optional(),
    transferPrice: z.number().optional(),
});
export const estimateResponseFlightSegmentSchema = z.object({
    id: z.string(),
    airline: airportOptionSchema,
    arrival: airportOptionSchema,
    arrivalTime: z.string(),
    date: z.coerce.date(),
    departure: airportOptionSchema,
    departureTime: z.string(),
    description: z.string().optional(),
    flightNumber: z.string().optional(),
    flightPrice: z.number().optional(),
    insuranceIncluded: z.boolean().optional(),
    insurancePrice: z.number().optional(),
    operatingAirline: airportOptionSchema.optional(),
    travelClass: z.enum(['ECONOMY', 'PREMIUM', 'BUSINESS']).optional(),
    travelerPrices: z.record(z.string(), z.number()).optional(),
    travelers: z.number().optional(),
    type: z.enum(['internal', 'outbound', 'return']),
});
export const estimateResponseVersionSchema = z.object({
    id: z.string(),
    name: z.string(),
    additionalNotes: z.string().nullable().optional(),
    adultPrice: z.number().optional(),
    balanceDeadline: z.coerce.date().optional(),
    carRentals: z.array(carRentalDetailsSchema).optional(),
    childPrice: z.number().optional(),
    depositAmount: z.number(),
    depositDeadline: z.coerce.date(),
    estimateDate: z.coerce.date(),
    exchangeAllowed: z.boolean().optional(),
    exchangeFee: z.number().optional(),
    flightSegments: z.array(estimateResponseFlightSegmentSchema),
    hotels: z.array(hotelDetailsSchema).optional(),
    infantPrice: z.number().optional(),
    luggageCabinCount: z.number().optional(),
    luggageCabinWeight: z.number().optional(),
    luggageHoldCount: z.number().optional(),
    luggageHoldWeight: z.number().optional(),
    numberOfPayments: z.number().optional(),
    passengerTypes: z.array(z.string()).optional(),
    pnr: z.string(),
    refundAllowed: z.boolean().optional(),
    refundFee: z.number().optional(),
    seniorPrice: z.number().optional(),
    totalPrice: z.number().optional(),
    totalPriceWithInsurance: z.number().optional(),
    validityDate: z.coerce.date(),
    youngsterPrice: z.number().optional(),
});
export const createEstimateResponseSchema = z.object({
    version: estimateResponseVersionSchema,
});
export const ALLOWED_ATTACHMENT_TYPES = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];
export const addAttachmentSchema = z.object({
    fileId: z.string(),
    fileName: z.string(),
    fileType: z.enum(ALLOWED_ATTACHMENT_TYPES, {
        message: 'Type de fichier non autorise. Types acceptes: PDF, DOC, DOCX, JPG, JPEG, PNG',
    }),
});
export const importPnrSchema = z.object({
    accountCode: z.string().optional(),
    bookingReference: z.string().min(1, 'La référence du dossier est requise'),
});
export const sendBulkEstimateResponsesSchema = z.object({
    responseIds: z.array(z.string()).min(1, 'Au moins un devis à envoyer'),
});
